import { render, staticRenderFns } from "./RegressionFairnessSubplotRelative.vue?vue&type=template&id=fcbad018&"
import script from "./RegressionFairnessSubplotRelative.vue?vue&type=script&lang=js&"
export * from "./RegressionFairnessSubplotRelative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports